
import React, { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";
import AdminPointsControlPanel from "@/components/admin/points/AdminPointsControlPanel";
import { usePermissions } from "@/hooks/use-permissions";
import { Navigate } from "react-router-dom";
import AdminSidebar from "@/components/admin/AdminSidebar";
import AdminHeader from "@/components/admin/AdminHeader";
import { useIsMobile } from "@/hooks/use-mobile";

const AdminPointsManagement = () => {
  const { isSuperAdmin } = usePermissions();
  const isMobile = useIsMobile();
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);

  // Redirect non-super-admin users
  if (!isSuperAdmin()) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex min-h-screen bg-nation-purple/10 dark:bg-gray-900/90">
      {/* Mobile sidebar toggle */}
      {isMobile && !sidebarOpen && (
        <Button
          variant="outline"
          size="icon"
          className="fixed top-4 left-4 z-40 md:hidden"
          onClick={() => setSidebarOpen(true)}
        >
          <Menu className="h-4 w-4" />
        </Button>
      )}
      
      {/* Sidebar with conditional display for mobile */}
      <div className={`${sidebarOpen ? "block" : "hidden"} ${isMobile ? "fixed inset-0 z-50 bg-black/50" : ""}`} onClick={isMobile ? () => setSidebarOpen(false) : undefined}>
        <div onClick={e => isMobile && e.stopPropagation()} className={isMobile ? "h-full w-64" : ""}>
          <AdminSidebar onClose={isMobile ? () => setSidebarOpen(false) : undefined} />
        </div>
      </div>
      
      <div className="flex-1">
        <AdminHeader onMenuClick={isMobile ? () => setSidebarOpen(true) : undefined}>
          Points Management
        </AdminHeader>
        
        <main className="p-4 md:p-6 mt-16 space-y-4 md:space-y-6">
          <div className="max-w-5xl mx-auto">
            <h1 className="text-3xl font-bold mb-6 text-nation-blue dark:text-blue-300">
              Points System Management
            </h1>

            <AdminPointsControlPanel />
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminPointsManagement;
